const mainColors = {
  primary: '#087f7a',
  purple: '#8f61d2',
  brown: '#8d6e63',
  pink: '#d63c70',
  neutral: '#b5bcc7',
  success: '#63a45f',
  warning: '#d29a4d',
  danger: '#c96d68',
  info: '#629dc4',
};

const lightStatusColors = {
  success: '#63a45f',
  danger: '#c96d68',
  warning: '#d29a4d',
  brown: '#967a70',
};

const darkStatusColors = {
  success: '#4f8f4b',
  danger: '#b95d56',
  warning: '#bd8128',
  brown: '#7f665e',
};

export const colors = {
  light: {
    bg: '#f6f7f9',
    surface: '#ffffff',
    surfaceAlt: '#f2f4f6',
    text: '#17191c',
    textMuted: '#626973',
    border: '#e1e5e9',
    divider: '#eceef1',
    ...mainColors,
    ...lightStatusColors,
  },
  dark: {
    bg: '#0f1115',
    surface: '#15181d',
    surfaceAlt: '#111419',
    text: '#f1f3f5',
    textMuted: '#9da5b1',
    border: '#2a3038',
    divider: '#232932',
    ...mainColors,
    primary: '#007f7f',
    purple: '#7f5eb8',
    pink: '#b94468',
    neutral: '#a4abb6',
    info: '#4d86b2',
    ...darkStatusColors,
  },
} as const;

export type ColorMode = keyof typeof colors;
